import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextAlignmentLeft16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconTextAlignmentLeft16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.5 4a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1zm0 3a.5.5 0 0 1 0-1H11a.5.5 0 0 1 0 1zM2 12.5a.5.5 0 0 0 .5.5H11a.5.5 0 0 0 0-1H2.5a.5.5 0 0 0-.5.5m.5-2.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextAlignmentLeft16);
